import { Button, MenuItem, Typography, ListItemIcon } from '@material-ui/core';
import React from 'react';
import { requiredLogin } from '../../../../middlewares';
import * as AuthSelectors from 'redux/reducers/gl_auth_reducer/selectors';
import MenuIcon from '@material-ui/icons/Menu';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import FormattedMenu from 'components/atoms/FormattedMenu';
import { ProfileConfiguration } from '../configuration';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import Avatar from 'components/atoms/Avatar';
import useStyles from '../styles';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Environment } from 'config';
import useMobile from 'hooks/useMobile';
import { APP_COLOR_SECONDARY } from 'styles/colors';

const useLocalStyles = makeStyles((theme) => ({
  customAvatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: '#fff !important',
    fontSize: 10,
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  },
}));
const menuId = 'navProfile';

const ProfileButton = () => {
  const theme = useTheme();
  const { username, email, picture } = AuthSelectors.useSelectUserData();
  const localClasses = useLocalStyles();
  const classes = useStyles({});

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const dispatch = useDispatch();
  const history = useHistory();
  const isMobile = useMobile();

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const renderProfileMenu = (
    <FormattedMenu
      anchorEl={anchorEl}
      id={menuId}
      keepMounted
      elevation={1}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {ProfileConfiguration.map((props, index: number) => (
        <MenuItem
          style={{ marginLeft: props.submenu ? 5 : 0 }}
          key={index}
          onClick={() => {
            props.action(dispatch, history);
            handleMenuClose();
          }}
        >
          {props.icon && (
            <ListItemIcon color="inherit">{props.icon}</ListItemIcon>
          )}
          <Typography color="inherit">{props.label}</Typography>
        </MenuItem>
      ))}
    </FormattedMenu>
  );

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <div
      className={classes.navbarElementSpacing}
      style={{ display: 'flex', alignItems: 'center', margin: 'auto' }}
    >
      {isMobile ? (
        <>
          <Avatar
            aria-controls={menuId}
            className={localClasses.customAvatar}
            name={username || email?.split('@')?.[0] || ''}
            image={
              picture ? `${Environment.API_BASE_URL}/${picture}` : undefined
            }
            onClick={handleProfileMenuOpen}
          />
        </>
      ) : (
        <Button
          aria-controls={menuId}
          color="inherit"
          onClick={handleProfileMenuOpen}
          endIcon={
            <Avatar
              className={localClasses.customAvatar}
              name={username || email?.split('@')?.[0] || ''}
              image={
                picture ? `${Environment.API_BASE_URL}/${picture}` : undefined
              }
            />
          }
          startIcon={<MenuIcon />}
          variant="outlined"
          style={{
            borderRadius: 150,
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            height: '100%',
            padding: '0.5rem 1rem 0.5rem 1rem',
            whiteSpace: 'nowrap',
            backgroundColor: APP_COLOR_SECONDARY({
              darkMode: theme.palette.type === 'dark',
              transparency: 1,
            }),
            color: 'white',
          }}
        >
          <TranslatedTextV2
            defaultText={username || email?.split('@')?.[0] || ''}
            translationKey="-"
          />
        </Button>
      )}
      {renderProfileMenu}
    </div>
  );
};

export default requiredLogin(ProfileButton);

// withRoles(ProfileButton, Roles.Registered);
